import { renewAndSave } from '../../lib/analytics/events';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RenewAndSaveSelection.module.scss';
import Button from '../../components/Button';
import { useLocation } from 'react-router-dom';

export default function RenewAndSaveComplete() {
  const { t } = useTranslation();
  useEffect(() => renewAndSave.successfullyRenewedAndSaved(), []);

  const location = useLocation<{ termMonths: number }>();

  return (
    <div className={styles.simpleFullWidthWrapper}>
      <div className={styles.simpleContainer}>
        <div className={styles.simpleSpacer} />
        <div className={styles.simpleHeaderContainer}>
          <h1 className={styles.simpleHeader}>{t('thank_you')}</h1>
          <p className={styles.simpleSubheader}>
            {t('youve_successfully_renewed_your_membership_another_months', { months: location.state.termMonths })}
          </p>
        </div>
        <Button
          className={styles.simpleButton}
          onClick={() => {
            window.open('fi://closeappview');
          }}
        >
          {t('done')}
        </Button>
      </div>
    </div>
  );
}
